var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1748 23.75C23.388 23.75 28.4248 18.7132 28.4248 12.5C28.4248 6.2868 23.388 1.25 17.1748 1.25C10.9616 1.25 5.9248 6.2868 5.9248 12.5C5.9248 18.7132 10.9616 23.75 17.1748 23.75Z",
    stroke: "#386DF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1748 17.5C19.9362 17.5 22.1748 15.2614 22.1748 12.5C22.1748 9.73858 19.9362 7.5 17.1748 7.5C14.4134 7.5 12.1748 9.73858 12.1748 12.5C12.1748 15.2614 14.4134 17.5 17.1748 17.5Z",
    stroke: "#386DF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.55L12.8 32.8C12.7564 32.9758 12.676 33.1403 12.5639 33.2825C12.4518 33.4248 12.3107 33.5415 12.15 33.625C11.9804 33.6986 11.7974 33.7366 11.6125 33.7366C11.4276 33.7366 11.2446 33.6986 11.075 33.625L2.77498 30C2.60089 29.9177 2.44769 29.797 2.32691 29.647C2.20612 29.4971 2.12087 29.3217 2.07757 29.134C2.03427 28.9464 2.03404 28.7514 2.07689 28.5636C2.11974 28.3759 2.20456 28.2003 2.32498 28.05L8.74998 20",
    stroke: "#386DF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.4254L22.25 32.8004C22.2947 32.9792 22.3785 33.1458 22.4952 33.2884C22.6118 33.4311 22.7586 33.5461 22.925 33.6254C23.09 33.6999 23.269 33.7385 23.45 33.7385C23.631 33.7385 23.81 33.6999 23.975 33.6254L32.225 30.0004C32.4017 29.9191 32.557 29.7976 32.6785 29.6457C32.8001 29.4938 32.8845 29.3156 32.925 29.1254C32.9724 28.9393 32.9744 28.7445 32.9309 28.5574C32.8874 28.3704 32.7997 28.1965 32.675 28.0504L25.975 19.5254",
    stroke: "#386DF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.40f70ae9b285491fd1a29f9be18fdf94.svg";
export { ForwardRef as ReactComponent };